// Reschedule / cancel client hooks. They call ONLY the single API command (the orchestrator owns
// Zoom/notify/Healthie propagation — the frontend never sequences legs). Server-side window + slot
// guards are authoritative; these surface the resulting codes (too_late, slot_unavailable) so the
// UI can show the contact-support / pick-another-slot state. Shared shape with mobile (WF14).
import { useState } from "react";
import { ApiError } from "@forcebase-ai/api-client";
import type { RescheduleBody, CancelBody } from "@forcebase-ai/schema/patient";
import { useApi } from "../api";

export interface ActionResult {
  ok: boolean;
  code?: string;
  message?: string;
}

export function useAppointmentActions() {
  const api = useApi();
  const [busy, setBusy] = useState(false);

  async function run(fn: () => Promise<unknown>): Promise<ActionResult> {
    setBusy(true);
    try {
      await fn();
      return { ok: true };
    } catch (e) {
      if (e instanceof ApiError) return { ok: false, code: e.code, message: e.message };
      return { ok: false, code: "error", message: "Something went wrong" };
    } finally {
      setBusy(false);
    }
  }

  return {
    busy,
    reschedule: (id: string, body: RescheduleBody) => run(() => api.reschedule(id, body)),
    cancel: (id: string, body: CancelBody) => run(() => api.cancel(id, body)),
  };
}
